'use client';

import styled from '@emotion/styled';

export const StyledList = styled.ul`
  font-family: Arial;
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  margin-bottom: var(--list-margin-bottom, 48px);

  & > li {
    align-items: center;
    display: inline-flex;
    font-size: 16px;
    margin: 0;
    padding: 0;

    span {
      font-weight: 700;
      margin-right: 15px;
      color: #23085a;
    }

    & > img {
      margin-right: 12px;
      stroke: rgb(35, 8, 90);
    }
  }
`;
